/* DO NOT FORGET to add export of this file to /src/store/reducers/index.js */
import * as FP from 'utils/fp-js';

export const counter = (state, action) =>
  FP.match(action.type)
    .on('INCREMENT_COUNTER', state + (action.payload || 0))
    .on('DECREMENT_COUNTER', state - (action.payload || 0))
    .otherwise(state);
